import { isFunction, noop } from 'underscore';

function normalizeObserver(observer) {
  if (isFunction(observer)) {
    return {
      next: observer,
    };
  }
  return observer;
}

export class Observable {
  constructor(executor) {
    this.executor = executor;
  }

  subscribe(observer) {
    const unsubscribe = this.executor(normalizeObserver(observer)) || noop;
    const subscription = { unsubscribe };
    return subscription;
  }
}
